import React, { useEffect, useState } from 'react'
import { getDepotoLogoSrc, isStageEnvironment, STAGE_SERVER_TOOLTIP } from '../utils'
import BannerLogo from '../assets/img/login_img.png'
import { Btn, FormInput } from '../components'
import { useNavigate, useLocation } from 'react-router'
import { useCore, useLogin } from '../hooks'
import { DepotoCore } from 'depoto-core'
import { wait } from '../utils'
import {toast} from "react-toastify";

type Props = {
  core: DepotoCore
}

export const LoginPin: React.FC<Props> = ({ core }) => {
  const [pin, setPin] = useState('')
  const [isFetching, setIsFetching] = useState(false)
  const [error, setError] = useState<string>('')

  const navigate = useNavigate()
  const location: any = useLocation()
  const { handleLogin, handleLoginByPin, handleLoginBySessionSwitch, handleAuthInit, isLoggedIn, sessions } = useLogin()
  const { setSelectedChildCompany } = useCore()
  const { from } = location.state || { from: { pathname: '/' } }
  const hasStageSession = sessions.some(s => s.server === 'stage')
  const clientType = hasStageSession ? 'stage' : window.depotoEnv
  const depotoLogo = getDepotoLogoSrc('login', clientType)
  const isStageLogo = isStageEnvironment(clientType)

  // const contentSpace: any = useRef(null)

  const login = async () => {
    if (!pin || !pin?.length) {
      toast.warning('Zadejte PIN')
      return
    }
    const session = sessions.find(s => s.user.pin === pin);
    if (session) {
      toast.success('Probíhá přihlašování ...')
      // console.log('PIN for session:', {session})
    } else {
      return
    }
    setIsFetching(true)
    // await handleLoginBySessionSwitch(session.session, core)
    // const isAuthenticated = true
    // const isAuthenticated = await handleLogin(session.session.email, session.session.password, session.server, undefined, core)
    const isAuthenticated = await handleLoginByPin(session.session, core)
    // console.log('loginComponent', { isAuthenticated })
    await wait(1000)
    setIsFetching(false)
    if (!isAuthenticated) {
      setError('Chyba při přihlašování') // todo
    } else {
      setError('')
      setSelectedChildCompany(undefined)
      if (from?.pathname === '/login/pin') {
        from.pathname = '/'
      }
      navigate(from)
    }
  }

  useEffect(() => {
    if (sessions?.length) {
      // console.log({sessions})
    }
  }, [sessions])

  return (
    <div className="grid grid-cols-3 h-screen">
      <div className="col-span-1 p-12 bg-primary flex flex-col justify-between xs:hidden">
        <div className="grid grid-cols-1 gap-6">
          <div className="col-span-1 text-white font-black sm:text-5xl lg:text-6xl ">Pokladní</div>
          <div className="col-span-1 text-white font-black sm:text-5xl lg:text-6xl ">aplikace</div>
        </div>
        <div className="flex justify-center items-end flex-1">
          <img src={BannerLogo} alt="Depoto Logo" className="sm:w-64 lg:w-auto object-contain" />
        </div>
      </div>

      <div className="col-span-2 flex justify-center items-center bg-base-blue xs:col-span-4">
        <div className="xs:p-0 mx-auto md:w-full md:max-w-md">
          <div className="card-login">
            <div className="grid grid-cols-2 mb-6 gap-3 items-center">
              <div className="col-span-1 flex items-center text-xl text-black font-bold">Přihlášení PINem</div>
              <div
                className={`col-span-1 text-right flex justify-end ${isStageLogo ? 'tooltip tooltip-bottom' : ''}`}
                data-tip={isStageLogo ? STAGE_SERVER_TOOLTIP : undefined}
              >
                <img
                  src={depotoLogo}
                  alt="Depoto Logo"
                  className={`login-card-logo ${isStageLogo ? 'login-card-logo--stage depoto-logo--stage' : ''}`}
                />
              </div>
            </div>
            <div className="flex flex-col gap-3 mb-4">
              <FormInput
                className="login-pin-input"
                type={'password'}
                inputclassName={'text-left w-full'}
                label={'PIN'}
                labelClassName="text-xs uppercase tracking-wide text-base-400"
                value={pin}
                onChange={setPin}
                onSubmit={login}
                debounceMs={0} // for what fucking reason we need default 500ms debounce on every input :'(
              />
            </div>
            <Btn
              className={'btn-primary w-full'}
              icon={'fa-sign-in-alt'}
              children={'Přihlásit'}
              title={'Přihlásit'}
              isDisabled={isFetching}
              isLoading={isFetching}
              onClick={login}
            />
            <Btn
              className={'btn-default w-full mt-2'}
              icon={'fa-sign-out-alt'}
              children={'Odhlásit'}
              title={'Odhlásit'}
              isDisabled={isFetching}
              isLoading={isFetching}
              onClick={() => navigate('/login')}
            />
            <div>{error}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
